// 簡易メールバリデーション (十分軽量で一般用途向け)
export function validateEmailFormat(value) {
  if (!value) return false;
  const v = value.trim();
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(v);
}

export function normalizeEmail(value) {
  return (value || '').trim();
}
